import { render, staticRenderFns } from "./CookiePolicy.vue?vue&type=template&id=2ddc6bfd&scoped=true&"
import script from "./CookiePolicy.vue?vue&type=script&lang=js&"
export * from "./CookiePolicy.vue?vue&type=script&lang=js&"
import style0 from "./CookiePolicy.vue?vue&type=style&index=0&id=2ddc6bfd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddc6bfd",
  null
  
)

export default component.exports